/**
 * Reusable Confirmation Dialog (PR A10)
 * Used for destructive actions (lock, unlock, reset password, impersonate)
 * Also used for success/info confirmations
 */
import React from 'react';
import { Button } from '../ui/button';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  confirmButtonClass = 'btn-confirm',
  showCancelButton = true,
  showInput = false,
  inputPlaceholder = '',
  inputValue = '',
  onInputChange = () => {}
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    if (onClose) onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (showCancelButton && onClose) onClose();
      else handleConfirm();
    } else if (e.key === 'Enter' && !showInput) {
      handleConfirm();
    }
  };

  const handleBackdropClick = () => {
    if (showCancelButton && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="confirm-dialog-backdrop" 
        onClick={handleBackdropClick}
        onKeyDown={handleKeyDown}
        role="presentation"
      />
      
      {/* Dialog */}
      <div className="confirm-dialog" role="dialog" aria-labelledby="dialog-title">
        <div className="confirm-dialog-header">
          <h3 id="dialog-title">{title}</h3>
        </div>

        <div className="confirm-dialog-body">
          <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
          
          {showInput && (
            <input
              type="text"
              className="confirm-dialog-input"
              placeholder={inputPlaceholder}
              value={inputValue}
              onChange={(e) => onInputChange(e.target.value)}
              autoFocus
            />
          )}
        </div>

        <div className="confirm-dialog-footer">
          {showCancelButton && (
            <Button 
              variant="outline"
              onClick={onClose}
            >
              {cancelText}
            </Button>
          )}
          <Button 
            variant={confirmButtonClass === 'btn-confirm-danger' || confirmButtonClass === 'btn-danger' ? 'destructive' : 'default'}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
